import { html, nothing } from "lit";
import { bibleScreenshotUrl } from "./bible-screenshots.ts";
import type { HelpArticleImage } from "./help-content.ts";

export function renderHelpArticleScreenshots(images: HelpArticleImage[] | undefined) {
  if (!images || images.length === 0) {
    return nothing;
  }
  return html`
    <section class="help-block help-block--shots" aria-label="Screenshots">
      <div class="help-shots">
        ${images.map((image) => {
          const src = bibleScreenshotUrl(image.file);
          if (!src) {
            return nothing;
          }
          return html`
            <figure class="help-shot">
              <img
                src=${src}
                alt=${image.alt}
                data-testid="help-screenshot"
                data-file=${image.file}
              />
              <figcaption class="muted">${image.alt}</figcaption>
            </figure>
          `;
        })}
      </div>
    </section>
  `;
}
